var map = {
	"./animal.html": "./src/components/library/htmlEditor/components/defaultProjects/html/animal.html",
	"./bio-page.html": "./src/components/library/htmlEditor/components/defaultProjects/html/bio-page.html",
	"./book.html": "./src/components/library/htmlEditor/components/defaultProjects/html/book.html",
	"./food.html": "./src/components/library/htmlEditor/components/defaultProjects/html/food.html",
	"./movie.html": "./src/components/library/htmlEditor/components/defaultProjects/html/movie.html",
	"./name.html": "./src/components/library/htmlEditor/components/defaultProjects/html/name.html",
	"./quiz.html": "./src/components/library/htmlEditor/components/defaultProjects/html/quiz.html",
	"./sports.html": "./src/components/library/htmlEditor/components/defaultProjects/html/sports.html",
	"./table.html": "./src/components/library/htmlEditor/components/defaultProjects/html/table.html",
	"./vacation.html": "./src/components/library/htmlEditor/components/defaultProjects/html/vacation.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/library/htmlEditor/components/defaultProjects/html sync \\.html$";